import React from 'react';
import {
  DeliverStatusCssClasses,
  DeliverStatusTitles,
} from './../../DeliveriesUIHelpers';

export function StatusColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `label label-lg label-${DeliverStatusCssClasses[cellContent]} label-inline`;
  };
  return (
    <span className={getLabelCssClasses()}>
      {DeliverStatusTitles[cellContent]}
    </span>
  );
}
